import { GridLayout } from "@arelia-components/layout/GridLayout";
import { UserActivitiesContainer } from "./components/UserActivities/UserActivitiesContainer";

export default function HqManagePresenter() {
  return <GridLayout>
    <UserActivitiesContainer />
  </GridLayout>;
}
